import React from 'react';

import {
  Listing,
} from '@reverbdotcom/commons/src/rql';

export interface IBulkSelectState {
  selectedListings: Listing[];
  selectableListings: Listing[];
}

interface IBulkSelectContext {
  bulkSelectState: IBulkSelectState;
  dispatch: React.Dispatch<any>;
}

export default React.createContext<IBulkSelectContext>({
  bulkSelectState: null,
  dispatch: () => {},
});
